<template>
  <div class="row mb-4">
    <div class="col-lg-7">
      <div class="content-block">
        <div class="content-block__header mb-3">
          <div class="content-block__title">Extract Text</div>
          <!--
          <div class="content-block__actions col-auto">
            <ul>
              <li>
                <button class="label__button label__open-browser" @click="openLink" title="Open in browser"><svg viewBox="0 0 511.626 511.627"><path d="M392.857,292.354h-18.274c-2.669,0-4.859,0.855-6.563,2.573c-1.718,1.708-2.573,3.897-2.573,6.563v91.361c0,12.563-4.47,23.315-13.415,32.262c-8.945,8.945-19.701,13.414-32.264,13.414H82.224c-12.562,0-23.317-4.469-32.264-13.414c-8.945-8.946-13.417-19.698-13.417-32.262V155.31c0-12.562,4.471-23.313,13.417-32.259c8.947-8.947,19.702-13.418,32.264-13.418h200.994c2.669,0,4.859-0.859,6.57-2.57c1.711-1.713,2.566-3.9,2.566-6.567V82.221c0-2.662-0.855-4.853-2.566-6.563c-1.711-1.713-3.901-2.568-6.57-2.568H82.224c-22.648,0-42.016,8.042-58.102,24.125C8.042,113.297,0,132.665,0,155.313v237.542c0,22.647,8.042,42.018,24.123,58.095c16.086,16.084,35.454,24.13,58.102,24.13h237.543c22.647,0,42.017-8.046,58.101-24.13c16.085-16.077,24.127-35.447,24.127-58.095v-91.358c0-2.669-0.856-4.859-2.574-6.57C397.709,293.209,395.519,292.354,392.857,292.354z"/><path d="M506.199,41.971c-3.617-3.617-7.905-5.424-12.85-5.424H347.171c-4.948,0-9.233,1.807-12.847,5.424c-3.617,3.615-5.428,7.898-5.428,12.847s1.811,9.233,5.428,12.85l50.247,50.248L198.424,304.067c-1.906,1.903-2.856,4.093-2.856,6.563c0,2.479,0.953,4.668,2.856,6.571l32.548,32.544c1.903,1.903,4.093,2.852,6.567,2.852s4.665-0.948,6.567-2.852l186.148-186.148l50.251,50.248c3.614,3.617,7.898,5.426,12.847,5.426s9.233-1.809,12.851-5.426c3.617-3.616,5.424-7.898,5.424-12.847V54.818C511.626,49.866,509.813,45.586,506.199,41.971z"/></svg></button>
              </li>
            </ul>
          </div>
          -->
        </div>
        <div class="content-block__body">
          <div class="subnote__transcript-title" v-if="subnote">URL: <a :href="subnote.link.url" target="_blank" class="subnote__article-url-link">{{ subnote.link.url }}</a></div>
          <div class="subnote__transcript-text">{{ subnote.text }}</div>
        </div>
      </div>
    </div>
    <div class="col-lg-5">        
      <div class="content-block">
        <div class="content-block__header row mb-3">
          <div class="content-block__title col">Label Highlighted Text</div>
          <div class="content-block__actions col-auto">
            <ul>
              <li>
                <button class="dashboard__button dashboard__delete-notes" @click="deleteSubnote" title="Delete subnote"><svg viewBox="0 0 515.556 515.556"><path d="m64.444 451.111c0 35.526 28.902 64.444 64.444 64.444h257.778c35.542 0 64.444-28.918 64.444-64.444v-322.222h-386.666z"/><path d="m322.222 32.222v-32.222h-128.889v32.222h-161.111v64.444h451.111v-64.444z"/></svg></button>
              </li>
            </ul>
          </div>
        </div>
        <div class="content-block__body mb-4">

          <!-- Targets -->
          <div class="row row--less-gutters mb-2">
            <div class="col">
              <div class="label__tt-title">3G & Targets</div>
            </div>
            <div class="col-auto">
              <button class="label__button label__add-tt" @click="showTargetModal" title="Select 3G & Targets"><svg viewBox="0 0 512 512"><path d="M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z"/><path d="M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z"/></svg></button>
            </div>
          </div>
          <div v-if="selectedTargets.length == 0" class="label__no-targets">
            There are no targets, <a @click="showTargetModal">add one</a>
          </div>
          <ul class="label__targets-list" v-if="selectedTargets">
            <li v-for="(target, index) in selectedTargets" :key="index">
              <template v-if="targetlanguage === 'IT'">
                <p>{{ target.label }}</p>
              </template>
              <template v-else>
                <p>{{ target.label_en }}</p>
              </template>
              <button @click="removeTarget(target)"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"></path></svg></button>
            </li>
          </ul>

          <!-- Taxonomies -->
          <div class="row row--less-gutters mb-2">
            <div class="col">
              <div class="label__tt-title">Taxonomies</div>
            </div>
            <div class="col-auto">
              <button class="label__button label__add-tt" @click="showTaxonomyModal" title="Select Taxonomies"><svg viewBox="0 0 512 512"><path d="M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z"/><path d="M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z"/></svg></button>
            </div>
          </div>
          <div v-if="selectedTaxonomies.length == 0" class="label__no-targets">
            There are no taxonomies, <a @click="showTaxonomyModal">add one</a>
          </div>
          <ul class="label__taxonomies-list" v-if="selectedTaxonomies">
            <li v-for="(taxonomy, index) in selectedTaxonomies" :key="index">
              <template v-if="taxonomylanguage === 'IT'">
                <p>{{ taxonomy.label }}</p>
              </template>
              <template v-else>
                <p>{{ taxonomy.label_en }}</p>
              </template>
              <button @click="removeTaxonomy(taxonomy)"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"></path></svg></button>
            </li>
          </ul>

        </div>
        <div class="content-block__header mb-3">
          <div class="content-block__title">Save Paragraph to Text File</div>
        </div>
        <div class="content-block__body">
          <div class="form-group row row--less-gutters">
            <div class="col">
              <select class="form-control form-control-sm" id="folder" v-model="selectedFolder" @change="getNotes(selectedFolder)">
                <option v-for="folder in folders" :key="folder.folder_slug" :value="folder">
                  {{ folder.folder_title }}
                </option>
              </select>
            </div>
            <div class="col-auto">
              <button @click="createFolder()" class="label__button label__add-tt" title="Add Folder"><svg viewBox="0 0 512 512"><path d="M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z"/><path d="M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z"/></svg></button>
            </div>
          </div>
          <div class="form-group row row--less-gutters">
            <div class="col">
              <select class="form-control form-control-sm" id="note" v-model="selectedNote">
                <option v-for="note in folderNotes" :key="note.note_slug" :value="note" >{{ note.note_title }}</option>
              </select>
            </div>
            <div class="col-auto">
              <button @click="createNote()" class="label__button label__add-tt" title="Add Note"><svg viewBox="0 0 512 512"><path d="M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z"/><path d="M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z"/></svg></button>
            </div>
          </div>
        </div>
        <div class="text-right">
          <button @click="updateSubnote()" class="btn btn-primary">Save</button>        
        </div>
      </div>
    </div>
    
    <TagsModal
      v-on:childToParent="updateSelectedTarget"
      v-show="isTargetModalVisible"
      @close="closeTargetModal"
      :tagValue="'tar'"
      :modalTitle="'3G & Target'"
      :text="subnote.text"
    />

    <TagsModal
      v-on:childToParent="updateSelectedTaxonomy"
      v-show="isTaxonomyModalVisible"
      @close="closeTaxonomyModal"
      :tagValue="'tax'"
      :modalTitle="'Taxonomies'"
      :text="subnote.text"
    />

  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import { mapGetters } from "vuex";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import TagsModal from './TagsModal.vue';
import {
  FETCH_FOLDERS,
  FOLDER_CREATE,
  // FETCH_NOTES,
  NOTE_CREATE,
  SUBNOTE_UPDATE,
  SUBNOTE_DELETE
} from "../store/actions.type";

export default {
  name: "Subnote",
  props: ['article', 'subnote', 'folder'],
  components: {
    TagsModal,
  },
  data(){
    return {
      folderNotes: [],
      target: '',
      selectedTargets: [],
      taxonomy: '',
      selectedTaxonomies: [],
      selectedFolder: null,
      selectedNote: null,
      isTaxonomyModalVisible: false,
      isTargetModalVisible: false,
      taxonomylanguage : 'IT',
      targetlanguage  : 'IT'    
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "folders", "currentFolder", "notes", "taxonomies", "targets"])
  },
  methods: {
    showTaxonomyModal() {
      this.isTaxonomyModalVisible = true;
    },
    showTargetModal() {
      this.isTargetModalVisible = true;
    },    
    closeTaxonomyModal() {
      this.isTaxonomyModalVisible = false;
    },
    closeTargetModal() {
      this.isTargetModalVisible = false;
    },
    createFolder: function() {
      Swal.fire({
        title: 'Add folder',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Add',
        showLoaderOnConfirm: true,
        preConfirm: (folderTitle) => {
          if(folderTitle == '') {
            return Swal.showValidationMessage(
              "Type folder name"
            )
          }
          let folderData = new FormData();
          folderData.set('folder_title', folderTitle);

          return this.$store.dispatch(FOLDER_CREATE, folderData);
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if(result.value.error) {
          Swal.fire(
            'Error!',
            result.value.error.message,
            'error'
          )
        } else {
          this.selectedFolder = result.value;
          Swal.fire(
            'Created!',
            'Your folder has been created.',
            'success'
          )
        }
      });
    },
    getNotes: function() {
      let slug = this.selectedFolder.folder_slug;
      ApiService.setHeader();
      ApiService.get("folders/" + slug + "/notes/")
      .then((response) => {
        this.folderNotes = response.data;
      });
      // return this.$store.dispatch(FETCH_NOTES, folder);
    },
    createNote: function() {
      Swal.fire({
        title: 'Add Note',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Add',
        showLoaderOnConfirm: true,
        preConfirm: (noteTitle) => {
          if(noteTitle == '') {
            return Swal.showValidationMessage(
              "Type note name"
            )
          }
          let noteData = new FormData();
          noteData.set('note_title', noteTitle);

          let payload = {
            'folder' : this.selectedFolder,
            'note' : noteData
          }

          return this.$store.dispatch(NOTE_CREATE, payload);
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if(result.value.error) {
          Swal.fire(
            'Error!',
            result.value.error.message,
            'error'
          )
        } else {
          this.getNotes();
          this.selectedNote = result.value;
          Swal.fire(
            'Created!',
            'Your note has been created.',
            'success'
          )
        }
      });
    },
    removeTarget: function(target) {
      var targetIndexToRemove = this.selectedTargets.indexOf(target);

      if (targetIndexToRemove > -1) {
        this.selectedTargets.splice(targetIndexToRemove, 1);
      }
    },
    removeTaxonomy: function(taxonomy) {
      var taxonomyIndexToRemove = this.selectedTaxonomies.indexOf(taxonomy);

      if (taxonomyIndexToRemove > -1) {
        this.selectedTaxonomies.splice(taxonomyIndexToRemove, 1);
      }
    },
    updateSubnote: function() {
      if(this.selectedTaxonomies.length == 0 
      || this.selectedTargets.length == 0
      || this.selectedFolder == null
      || this.selectedNote == null) {
        Swal.fire(
          'Missing fields!',
          'You must to populate all the fields',
          'warning'
        );
        return;
      }

      let errorGender = true;
      let errorGeolocalization = true;
      let errorGeneration = true;
      // let errorTarget = true;
 
      let idGender = null;
      let idGeolocalization = null;
      let idGeneration = null;
      // let idTarget = null;

      for (var l = this.targets.length - 1; l >= 0; l--) {
        if(this.targets[l].label == 'GENERE') {
          idGender = this.targets[l].gandtarget_id;
        }
        if(this.targets[l].label == 'GEOLOCALIZZAZIONE') {
          idGeneration = this.targets[l].gandtarget_id;
        }
        if(this.targets[l].label == 'GENERAZIONE') {
          idGeolocalization = this.targets[l].gandtarget_id;
        }
        // if(this.targets[l].label == 'TARGET') {
        //   idTarget = this.targets[l].gandtarget_id;
        // }
      }

      for (var k = this.selectedTargets.length - 1; k >= 0; k--) {
        if(this.selectedTargets[k].lev_1 == idGender) {
          errorGender = false;
        }
        if(this.selectedTargets[k].lev_1 == idGeolocalization) {
          errorGeolocalization = false;
        }
        if(this.selectedTargets[k].lev_1 == idGeneration) {
          errorGeneration = false;
        }
        // if(this.selectedTargets[k].lev_1 == idTarget) {
        //   errorTarget = false;
        // }
      }
      if(errorGender || errorGeolocalization || errorGeneration) {
         Swal.fire(
          'Missing fields!',
          'You must select gender, geolocalization and generation',
          'warning'
        );
        return;
      }

      let subNoteData = new FormData();
      var i;

      subNoteData.set('text', this.subnote.text);
      for (i = 0; i < this.selectedTaxonomies.length; i++) {
        subNoteData.append('taxonomies', this.selectedTaxonomies[i].tax_id);
      }
      for (i = 0; i < this.selectedTargets.length; i++) {
        subNoteData.append('targets', this.selectedTargets[i].gandtarget_id);
      }
      subNoteData.set('folder', this.selectedFolder.folder_id); 
      subNoteData.set('note', this.selectedNote.note_id); 
      subNoteData.set('link', this.subnote.link_id);

      let payload = {
        'subnote_id': this.subnote.subnote_id,
        'subNoteData': subNoteData
      }

      this.$store.dispatch(SUBNOTE_UPDATE, payload)
      .then(() => {
        Swal.fire(
        'Saved!',
        'Subnote has been saved.',
        'success'
        )
      });     
    },
    deleteSubnote() {

      let vm = this;

      Swal.fire({
        title: 'Move to trash',
        text: "Are you sure you want to move this item to the trash?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, move it!'
      }).then((result) => {
        if (result.value) {

          vm.$store.dispatch(SUBNOTE_DELETE, vm.subnote.subnote_id);

          Swal.fire({
            title: 'Moved to trash!',
            text: 'Your item has been moved to the trash.',
            icon: 'success'
          }).then(() => {
            vm.$destroy();
          });
        }
      }); 
      
    },
    openLink: function() {
      window.open(this.subnote.link.url);
    },
    updateSelectedTaxonomy: function(value) {
      if(!this.selectedTaxonomies.includes(value)){
        this.selectedTaxonomies.push(value);        
        Swal.fire(
          'Success!',
          'The ' + value.label + ' taxonomy has been added',
          'success'
        )
      } else {
        Swal.fire(
          'Error!',
          value.label + ' was already present',
          'error'
        )       
      }
    },
    updateSelectedTarget: function(value) {
      if(!this.selectedTargets.includes(value)){
        this.selectedTargets.push(value);       
        Swal.fire(
          'Success!',
          'The ' + value.label + ' target has been added',
          'success'
        )
      } else {
        Swal.fire(
          'Error!',
          value.label + ' was already present',
          'error'
        )       
      }
    }
  },
  mounted() {
    var i;
    var j;

    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
      return;
    }

    // if (!this.article) {
    //   this.$router.push({ name: "Search" });
    //   return;
    // }

    if(Object.keys(this.folders).length === 0) {
      this.$store.dispatch(FETCH_FOLDERS);
    }

    if(this.subnote.taxonomies.length > 0) {
      for(i = 0; i < this.subnote.taxonomies.length; i++){
        for(j = 0; j < this.taxonomies.length; j++){
          if(this.subnote.taxonomies[i] === this.taxonomies[j].tax_id){
            this.selectedTaxonomies.push(this.taxonomies[j]);
            break;
          }
        }
      }
    }

    if(this.subnote.targets.length > 0) {
      for(i = 0; i < this.subnote.targets.length; i++){
        for(j = 0; j < this.targets.length; j++){
          if(this.subnote.targets[i] === this.targets[j].gandtarget_id){
            this.selectedTargets.push(this.targets[j]);
            break;
          }
        }
      }
    }

    // Set selected folder and note
    if(this.folder) {
      this.selectedFolder = this.folder;
    } else {
      this.selectedFolder = this.subnote.folder;
    }

    let slug = this.selectedFolder.folder_slug;
    ApiService.setHeader();
    ApiService.get("folders/" + slug + "/notes/")
    .then((response) => {
      this.folderNotes = response.data;
    });

    // this.folderNotes = this.getNotes(this.selectedFolder);
    this.selectedNote = this.subnote.note;
  }
}
</script>

<style lang="scss">
  .subnote {

    &__article-url-link {
      color: $color-genoa;

      &:hover {
        color: $color-java;
        text-decoration: none;
      }
    }

    &__transcript-title {
      font-size: rem(16px);
      color: #000;
      font-weight: 700;
      margin-bottom: rem(12px);
    }

    &__transcript-text {
      min-height: rem(320px);
      font-family: $font-family-roboto;
      color: #000;
      font-size: rem(14px);
    }
  }
</style>
